/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */
import type {
  AppIconPreviewGalleryButtonSlots,
  AppIconPreviewGalleryButtonState,
} from "./AppIconPreviewGalleryButton.types";

import { assertSlots } from "@fluentui/react-components";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const renderAppIconPreviewGalleryButton = (
  state: AppIconPreviewGalleryButtonState
) => {
  assertSlots<AppIconPreviewGalleryButtonSlots>(state);
  return (
    <AppTooltipContainer {...state} showTooltip={state.showTooltip ?? true}>
      <state.root>
        {!state.hideLabel && state.buttonLabel && <state.buttonLabel />}
      </state.root>
    </AppTooltipContainer>
  );
};
